import { render, staticRenderFns } from "./edit_classin.vue?vue&type=template&id=23b2b988&scoped=true"
import script from "./edit_classin.vue?vue&type=script&lang=js"
export * from "./edit_classin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2b988",
  null
  
)

export default component.exports